"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { useEffect } from "react";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import SimpleCreateAgreementComponentOpen from "@portal/components/pages/agreements/simpleCreateAgreementOpen";
import useCenterIdOpenPages from "@portal/hooks/useCenterIdOpenPages";
import { useSession } from "@portal/auth/client/SessionProvider";

const SimpleOpenCreateAgreementClientComponent = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const centerId = useCenterIdOpenPages();

  const isin = searchParams?.get("isin") as string;
  const oneTimeDeposit = searchParams?.get("oneTimeDeposit") as string;
  const monthlyDeposit = searchParams?.get("monthlyDeposit") as string;
  const { session } = useSession();

  useEffect(() => {
    if (session?.status === "loading") return;
    if (session?.status === "authenticated") {
      router.push(
        `/createAgreement/simple?isin=${
          isin ?? "NO0010867682"
        }&oneTimeDeposit=${oneTimeDeposit}&monthlyDeposit=${monthlyDeposit}`,
      );
    }
  }, [centerId, isin, monthlyDeposit, oneTimeDeposit, router, session?.status]);

  return (
    <div>
      {session?.status === "authenticated" ? (
        <PageSpinner />
      ) : (
        <div className="flex justify-center">
          <SimpleCreateAgreementComponentOpen
            isin={isin}
            oneTimeDeposit={oneTimeDeposit}
            monthlyDeposit={monthlyDeposit}
            centerId={centerId}
          />
        </div>
      )}
    </div>
  );
};

export default SimpleOpenCreateAgreementClientComponent;
